// @flow

import React from 'react';

import styles from './summaryCard.scss';

type Props = {
  totalAmount?: numeric,
  totalAmountTag?: string,
  showPercentage?: boolean,
  percentage?: numeric,
  subAmountLeft?: numeric,
  subAmountLeftTag?: string,
  subAmountRight?: numeric,
  subAmountRightTag?: string,
  subAmountCenter?: numeric,
  subAmountCenterTag?: string,
  subAmountBottomLeft?: numeric,
  subAmountBottomLeftTag?: string,
  subAmountBottomRight?: numeric,
  subAmountBottomRightTag?: string,
  subAmountBottomCenter?: numeric,
  subAmountBottomCenterTag?: string,
  hideSummaryCardDown?: boolean,
  type?: string
};

const renderCenter = (prop: Props) => {
  if (!prop.subAmountCenterTag) {
    return null;
  }
  return (
    <div
      className={`${styles.subAmountCenterContainer} l-row a-center j-center`}
    >
      <div className={`${styles.subAmountTag}`}>
        {' '}
        {prop.subAmountCenterTag}{' '}
      </div>
      <div className={`${styles.subAmount}`}>
        &#8377;{Math.round(prop.subAmountCenter * 100) / 100}
      </div>
    </div>
  );
};

const renderItem = (label, value) => {
  return (
    <div className={`${styles.item}`}>
      <div className={`${styles.subAmountTag}`}> {label} </div>
      <div className={`${styles.subAmount}`}>
        &#8377;{Math.round(value * 100) / 100}
      </div>
    </div>
  );
};

const renderCollectionsInOneRow = (prop: Props) => {
  return (
    <div className={`${styles.summaryCardDown}`}>
      <div className={`${styles.rowContainer}`}>
        {renderItem(prop.subAmountLeftTag, prop.subAmountLeft)}
        {renderItem(prop.subAmountCenterTag, prop.subAmountCenter)}
        {renderItem(prop.subAmountRightTag, prop.subAmountRight)}
        {renderItem(prop.subAmountBottomLeftTag, prop.subAmountBottomLeft)}
        {renderItem(prop.subAmountBottomCenterTag, prop.subAmountBottomCenter)}
        {renderItem(prop.subAmountBottomRightTag, prop.subAmountBottomRight)}
      </div>
    </div>
  );
};

const SummaryCard = (prop: Props) => (
  <div className={`${styles.summaryCardContainer} flex l-col`}>
    <div className={`${styles.summaryCardUp} l-col j-center`}>
      <div className={`${styles.totalAmount}`}>
        &#8377;{Math.round(prop.totalAmount * 100) / 100}
      </div>
      <div className={`${styles.totalAmountTag}`}> {prop.totalAmountTag} </div>
      {prop.showPercentage ? (
        <div className={`${styles.percentagePaid} a-center j-center`}>
          {Math.round(prop.percentage)}%
        </div>
      ) : null}
    </div>
    {prop.type === 'HANDOVER' ? (
      <div>{renderCollectionsInOneRow(prop)}</div>
    ) : prop.hideSummaryCardDown ? null : (
      <div className={`${styles.summaryCardDown}`}>
        <div className="l-row">
          <div
            className={`${styles.subAmountLeftContainer} l-row a-center j-start`}
          >
            <div className={`${styles.subAmountTag}`}>
              {' '}
              {prop.subAmountLeftTag}{' '}
            </div>
            <div className={`${styles.subAmount}`}>
              &#8377;{Math.round(prop.subAmountLeft * 100) / 100}
            </div>
          </div>
          {renderCenter(prop)}
          <div
            className={`${styles.subAmountRightContainer} l-row a-center j-end`}
          >
            <div className={`${styles.subAmountTag}`}>
              {' '}
              {prop.subAmountRightTag}{' '}
            </div>
            <div className={`${styles.subAmount}`}>
              &#8377;{Math.round(prop.subAmountRight * 100) / 100}
            </div>
          </div>
        </div>
        <div className="l-row">
          {prop.subAmountBottomLeftTag ? (
            <div
              className={`${styles.subAmountLeftContainer} l-row a-center j-start`}
            >
              <div className={`${styles.subAmountTag}`}>
                {' '}
                {prop.subAmountBottomLeftTag}{' '}
              </div>
              <div className={`${styles.subAmount}`}>
                &#8377;{Math.round(prop.subAmountBottomLeft * 100) / 100}
              </div>
            </div>
          ) : (
            <div
              className={`${styles.subAmountLeftContainer} l-row a-center j-start`}
            />
          )}
          {prop.subAmountBottomCenterTag ? (
            <div
              className={`${styles.subAmountCenterContainer} l-row a-center j-center`}
            >
              <div className={`${styles.subAmountTag}`}>
                {' '}
                {prop.subAmountBottomCenterTag}{' '}
              </div>
              <div className={`${styles.subAmount}`}>
                &#8377;{Math.round(prop.subAmountBottomCenter * 100) / 100}
              </div>
            </div>
          ) : (
            <div
              className={`${styles.subAmountCenterContainer} l-row a-center j-center`}
            />
          )}
          {prop.subAmountBottomRightTag ? (
            <div
              className={`${styles.subAmountRightContainer} l-row a-center j-end`}
            >
              <div className={`${styles.subAmountTag}`}>
                {' '}
                {prop.subAmountBottomRightTag}{' '}
              </div>
              <div className={`${styles.subAmount}`}>
                &#8377;{Math.round(prop.subAmountBottomRight * 100) / 100}
              </div>
            </div>
          ) : (
            <div
              className={`${styles.subAmountRightContainer} l-row a-center j-end`}
            />
          )}
        </div>
      </div>
    )}
  </div>
);

export default SummaryCard;
